import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { useLogger, type InstrumentationLogging, type Logger } from './logger';
import { loggerPropTypesShape, defaultLogger } from './shape';

export interface LoggerContextProviderProps {
  children: React.ReactNode;
  logger?: InstrumentationLogging | null;
  defaultScenarioName?: string;
}

export const LoggerContext = React.createContext<Logger>(defaultLogger);

export const useLoggerContext = () => useContext(LoggerContext);

export const LoggerContextProvider = ({
  children,
  logger,
  defaultScenarioName,
}: LoggerContextProviderProps) => {
  const loggerProviderValue = useLogger({
    defaultScenarioName,
    logging: logger,
  });
  return (
    <LoggerContext.Provider value={loggerProviderValue}>
      {children}
    </LoggerContext.Provider>
  );
};

LoggerContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  logger: loggerPropTypesShape,
  defaultScenarioName: PropTypes.string,
};

LoggerContextProvider.defaultProps = {
  logger: defaultLogger,
  defaultScenarioName: '',
};
